module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-2700.539abe52.svg";